import { mapActions, mapState } from 'vuex'
import * as types from '@/store/types'
import { eventBus } from '@/app/event-bus'
import Helper from '@/utils/helper'

const AD_TEXT_TIMEOUT = 600000
const INTERVAL_RECONNECT = 300000

export default {
  data () {
    return {
      adPlaylistAccessErrorInterval: null
    }
  },
  computed: {
    ...mapState({
      playlistAdItems: state => state.playlist.adItems,
      playlistMainItems: state => state.playlist.adItems ? state.playlist.adItems.playlistsMainItems : []
    }),
    textPlayListExist () {
      return this.playlistAdItems ? !this.playlistAdItems?.isEmptyTextPlaylist() : null
    },
    playListEmpty () {
      return Helper.isEmpty(this.playlistMainItems)
    },
    playlistsAudioItems () {
      return this.playlistAdItems?.getPlaylistsAudioItems()
    },
    playlistsAudioItemsNotEmpty () {
      return Helper.isNotEmpty(this.playlistsAudioItems)
    }
  },
  methods: {
    ...mapActions({
      playlistAdItemsSet: types.PLAYLIST.adItems.set
    }),
    /**
     * Обновляем плейлист каждые 10 минут
     */
    updateAdPlaylist () {
      setTimeout(() => {
        this.setAdPlaylist()
      }, AD_TEXT_TIMEOUT)
    },
    setAdPlaylist () {
      clearInterval(this.adPlaylistAccessErrorInterval)
      return this.$service.getAdv()
        .then(data => {
          /**
           * Если нет текстового плейлиста, сразу записываем новый плейлист
           * Иначе отправляем событие, записать плейлист, когда закончится показ текущего плейлиста
           */
          if (!this.textPlayListExist) {
            this.playlistAdItemsSet(data)
          } else {
            eventBus.emitUpdateAdTextItems(data)
          }
          this.updateAdPlaylist()
        })
        .catch(e => {
            console.error('getAdv error: ', e)
          if (e.isAccessDenied()) {
            this.adPlaylistAccessErrorInterval = setInterval(() => {
              this.setAdPlaylist()
            }, INTERVAL_RECONNECT)
          }
        })
    }
  },
  mounted () {
    this.setAdPlaylist()
  }
}
